Ext.define('SA.view.settings.ChangeEmailWindow', {
    alias: 'widget.change-email-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-change-email-window',
    includeCancelBtn: true,
    title: 'Change Email Address',

    initComponent() {
        this.callParent();

        ['newEmail', 'newEmailAgain', 'password'].forEach(name => {
            var field = this[name] = this.down('#' + name);

            field.on({
                blur: this.refreshErrors,
                change: this.refreshErrors,
                focus: this.refreshErrors,

                scope: this
            });
        });

        this.saveButton = this.down('#saveButton');
    },

    afterRender() {
        this.callParent();

        this.newEmail.focus();
    },

    getBodyItems() {
        return [
            {
                xtype: 'simple-container',
                cls: 'sa-change-email-window-field-row',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-change-email-window-field-label',
                        html: 'New email address:'
                    }, {
                        xtype: 'sa-textfield',
                        cls: 'sa-change-email-window-field-input',
                        height: 35,
                        itemId: 'newEmail'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-change-email-window-field-row',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-change-email-window-field-label',
                        html: 'Retype email address:'
                    }, {
                        xtype: 'sa-textfield',
                        cls: 'sa-change-email-window-field-input',
                        height: 35,
                        itemId: 'newEmailAgain'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-change-email-window-field-row',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-change-email-window-field-label',
                        html: 'Current password:'
                    }, {
                        xtype: 'sa-textfield',
                        cls: 'sa-change-email-window-field-input',
                        height: 35,
                        inputType: 'password',
                        itemId: 'password'
                    }
                ]
            }
        ];
    },

    getFooterItems() {
        return {
            xtype: 'sa-button',
            disabled: true,
            handler: this.onContinueClick.bind(this),
            itemId: 'saveButton',
            text: 'Continue',
            ui: 'primary'
        };
    },

    onContinueClick() {
        this.setLoading('Updating email address…');

        SA.Ajax.request({
            method: 'update',
            resource: 'user/username',

            data: {
                password: this.password.getValue(),
                newUsername: this.newEmail.getValue()
            },

            expectedErrors: [
                'InvalidUserCredentialsException',
                'InvalidEmailAddressFormatException',
                'UsernameAlreadyExistsException'
            ]
        }).then(this.onUpdateSuccess.bind(this), this.onUpdateFailure.bind(this));
    },

    onUpdateFailure(error) {
        this.setLoading(false);

        var message = {
            InvalidUserCredentialsException: 'The password you’ve provided may be incorrect.',
            InvalidEmailAddressFormatException: 'The email address you’ve provided may not be valid.',
            UsernameAlreadyExistsException: 'The email address you’ve provided already has a SimplyAnalytics account.'
        }[error.getType()];

        if (!message) {
            return;
        }

        Ext.widget({xtype: 'alert', title: 'Change Failed', message: 'Your email address could not be changed.\n\n' + message});
    },

    onUpdateSuccess() {
        this.destroy();

        Ext.widget({
            xtype: 'alert',
            message: 'An email has been sent to your new email address.\n\nPlease follow the instructions to complete your email address change.',
            title: 'Almost done…'
        });

        var task = Ext.TaskManager.start({
            interval: 15000,

            run() {
                SA.Ajax.request({
                    method: 'get',
                    resource: 'user',

                    success(user) {
                        if (user.username !== SA.User.getUsername()) {
                            SA.User.setUsername(user.username);

                            Ext.TaskManager.stop(task);

                            SA.PageHeader.refresh();
                        }
                    }
                });
            }
        });
    },

    refreshErrors() {
        var passwordField = this.password,
            password = passwordField.getValue(),
            emailField = this.newEmail,
            email = emailField.getValue(),
            emailAgainField = this.newEmailAgain,
            emailAgain = emailAgainField.getValue(),
            emailRegex = /^(")?(?:[^\."])(?:(?:[\.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[\-\w]*\.){1,5}([A-Za-z]){2,6}$/,
            valid = true;

        passwordField.clearInvalid();
        emailField.clearInvalid();
        emailAgainField.clearInvalid();

        if (!emailRegex.test(email)) {
            valid = false;

            if (email) {
                emailField.markInvalid('This doesn’t appear to be a valid email address');
            }
        }
        else if (email === SA.User.getUsername()) {
            valid = false;

            emailField.markInvalid('Your new email address must be different from your old email address');
        }
        else if (email !== emailAgain) {
            valid = false;

            if (emailAgain) {
                emailAgainField.markInvalid('This entry must match the new email address entered above');
            }
        }
        else if (!password) {
            valid = false;
        }

        this.saveButton.setDisabled(!valid);
    }
});
